// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// shape: { user, loading, logout }
const AuthContext = createContext({
  user: null,
  loading: true,
  logout: () => { }
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch('/api/me', {
          credentials: 'include',
          headers: {
            'Cache-Control': 'no-cache',       // ✅ force fresh session
          }
        });
        if (!res.ok) throw new Error();
        const data = await res.json();
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    // Slight delay helps ensure cookie + session store sync
    setTimeout(fetchUser, 200);
  }, []);


  const logout = async () => {
    await fetch('/api/logout', { method: 'POST', credentials: 'include' });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// ← This MUST be here, exported as a _named_ function
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading…</div>;
  }
  if (!user) {
    // send them to /login, but remember where they came from
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
